

export default function ChartITem({ newData }: any) {
    const toJalali = (date: string) => {
        const utcDate = new Date(date);
        const localDate = utcDate.toLocaleString('fa-IR', {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
        });
        return localDate;
    };

    if (!newData || !Array.isArray(newData) || newData.length === 0) {
        return null;
    }

    const maxTotal = Math.max(...newData.map((item: any) => item.total || 0)) || 1;

    return (
        <div className="space-y-4">
            {/* Simple bar chart */}
            <div className="bg-gray-50 border border-gray-200 rounded-xl p-4">
                <div className="flex items-center justify-between mb-3" dir="rtl">
                    <h3 className="text-sm font-semibold text-gray-800">نمودار فروش روزانه (۳۰ روز اخیر)</h3>
                    <span className="text-[11px] text-gray-500">
                        بر اساس مبلغ فروش
                    </span>
                </div>
                <div className="h-48 flex items-end gap-2 overflow-x-auto pb-2" dir="ltr">
                    {newData.map((item: any, index: number) => {
                        const height = Math.max(8, (item.total / maxTotal) * 100);
                        const label = toJalali(item.date);
                        return (
                            <div key={index} className="flex flex-col items-center justify-end min-w-[28px]">
                                <div
                                    className="w-3 md:w-4 bg-blue-500 rounded-t-md"
                                    style={{ height: `${height}%` }}
                                    title={`${item.total.toLocaleString('fa-IR')} تومان`}
                                />
                                <span className="mt-1 text-[9px] text-gray-500 whitespace-nowrap">
                                    {label}
                                </span>
                            </div>
                        );
                    })}
                </div>
            </div>

            {/* Detail list */}
            <div className="h-64 bg-white border border-gray-200 rounded-xl overflow-hidden">
                <div className="flex justify-between bg-gray-50 border-b border-gray-200 p-3 text-xs font-semibold text-gray-600" dir="rtl">
                    <div>تعداد خرید</div>
                    <div>مبلغ</div>
                    <div>تاریخ</div>
                </div>
                <div className="h-full overflow-y-auto">
                    {newData.map((item: any, index: number) => (
                        <div
                            key={index}
                            className="flex justify-between items-center px-3 py-2 text-sm border-b border-gray-100 hover:bg-gray-50"
                        >
                            <div>{item.count}</div>
                            <div>{item.total.toLocaleString('fa-IR')} تومان</div>
                            <div dir="ltr" className="text-xs text-gray-600">
                                {toJalali(item.date)}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
